import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { RootState, Dispatcher } from 'AppTypes'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { DayOfWeeks } from '@share/const'
import { getIconByName } from '@share/helper'
import plateIcon from '@app/layouts/html/assets/img/icon-2309.png'
import playYellow from '@app/layouts/html/assets/img/Polygon-6.png'
import playRed from '@app/layouts/html/assets/img/Polygon-61.png'
import VideoPopup from './popup/VideoPopup'
import ListVideoGoLiver from './partials/ListVideoGoLiver'
import VideoGoLiverSummary from './partials/VideoGoLiverSummary'
import * as actions from './state_management/actions'

const mapStateToProps = (state: RootState) => ({
  isLoading: state.store.isLoading,
  storeDetails: state.store.storeDetails,
  videoGoLiver: state.store.videoGoLiver,
  currentLocation: state.store.currentLocation
})

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  fetchStore: (id: string) => dispatch(actions.fetchStore(id)),
  fetchVideoGoLiver: (params: any) => dispatch(actions.fetchVideoGoLiver(params)),
  fetchCurrentLocation: () => dispatch(actions.fetchCurrentLocation()),
  setIsLoading: (isLoading: boolean) => dispatch(actions.setLoading(isLoading)),
  updateViewVideo: (video: any) => dispatch(actions.updateViewVideo(video))
})

const latitudeField: number = 0
const longitudeField: number = 0

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const StoreDetails: React.FC<Props> = ({
  storeDetails,
  fetchStore,
  updateViewVideo
}) => {
  const [showVideoPopup, setShowVideoPopup] = useState(false)
  const [selectedVideo, setSelectedVideo] = useState()
  const [latitude, setLatitude] = useState(latitudeField)
  const [longitude, setLongitude] = useState(longitudeField)
  const { t } = useTranslation()
  const { id } = useParams<{ id: string }>()
  useEffect(() => {
    fetchStore(id)
    navigator.geolocation.getCurrentPosition((position: any) => {
      setLatitude(position.coords && position.coords.latitude)
      setLongitude(position.coords && position.coords.longitude)
    })
  }, [fetchStore, id])

  const getDistanceFromLatLonInKm = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    const R = 6371 // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1) // deg2rad below
    const dLon = deg2rad(lon2 - lon1)
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
      + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2))
      * Math.sin(dLon / 2) * Math.sin(dLon / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const d = R * c // Distance in km
    return Math.ceil(d)
  }
  const deg2rad = (deg: number) => (
    deg * (Math.PI / 180)
  )

  const getLocation = (locationStore: string) => {
    const arrLocationStore = locationStore ? locationStore.split(',') : []
    const value = getDistanceFromLatLonInKm(arrLocationStore && parseFloat(arrLocationStore[0]),
      arrLocationStore && parseFloat(arrLocationStore[1]),
      latitude, longitude)
    return `${value} Km`
  }

  const formatOpenCloseTime = (timeRange: any) => {
    const openHour: number = timeRange.open.hour
    const openMinute: number = timeRange.open.minute
    const closeHour: number = timeRange.close.hour
    const closeMinute: number = timeRange.close.minute
    const openHourStr = (openHour < 10) ? `0${openHour}` : openHour
    const openMinuteStr = (openMinute < 10) ? `0${openMinute}` : openMinute
    const closeHourStr = (closeHour < 10) ? `0${closeHour}` : closeHour
    const closeMinuteStr = (closeMinute < 10) ? `0${closeMinute}` : closeMinute

    return (` ${openHourStr}:${openMinuteStr} ~ ${closeHourStr}:${closeMinuteStr}`)
  }

  const onSelectVideo = (video: any) => {
    setSelectedVideo(video)
    setShowVideoPopup(true)
  }

  const onCloseVideoPopup = () => {
    setShowVideoPopup(false)
  }
  return (

    <div className="main-detail">
      {selectedVideo
        && (
          <VideoPopup
            video={selectedVideo}
            showModal={showVideoPopup}
            onCloseModal={onCloseVideoPopup}
            updateStateViewVideo={updateViewVideo}
          />
        )}
      <div className="row shop-detail">
        <div className="col-md-6">
          <h2>{storeDetails.storeName} </h2>
          <h4><img src={plateIcon} alt="" /> {t('store.detailsInformation')}</h4>
          <div className="mt-4 mb-4">
            {storeDetails.address}<br />
            <br /><br />
            電  話：{storeDetails.phonenumber}<br />

          </div>
          <div className="map mb-4">
            <iframe
              src={`https://maps.google.com/maps?q=${storeDetails.location}&hl=jp&z=14&amp&output=embed`}
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              title="map"
            />
          </div>
          <div className="mb-4 mb-4">
            <div className="d-flex">
              <div>営業時間：</div>
              <div>
                {storeDetails.businessSchedule
                  && storeDetails.businessSchedule.workingDays.map((item: any, index: number) => {
                    const res = {
                      ...item,
                      id: index
                    }
                    return res
                  })
                    .map((item: any) => (
                      !item.isOff
                      && item.timeRanges
                      && item.timeRanges.length > 0
                      && (
                        <div key={item.id}>
                          {t(`store.businessHours.${DayOfWeeks[item.dayOfWeek]}`)} :
                          {
                            formatOpenCloseTime(item.timeRanges[0])
                          }
                        </div>
                      )
                    ))}
              </div>
            </div>
            <div className="d-flex">
              <div>定休日：</div>
              <div>
                {storeDetails.businessSchedule
                  && storeDetails.businessSchedule.workingDays.map((item: any, index: number) => {
                    const res = {
                      ...item,
                      id: index
                    }
                    return res
                  })
                    .map((item: any) => (
                      item.isOff
                      && (
                        <div key={item.id}>
                          {t(`store.businessHours.${DayOfWeeks[item.dayOfWeek]}`)}
                          <br />
                        </div>
                      )
                    ))}
              </div>
            </div>
          </div>
          <h4><img src={plateIcon} alt="" />   {t('store.detailsInformation')}</h4>
          <div className="mb-5">
            {t('store.reserveOption')} :  {storeDetails.canReserve ? t('store.yes') : t('store.no')}<br />
            {t('store.charter')} :  {storeDetails.reservationInfo && storeDetails.reservationInfo.reservationDetail}<br />
            {t('store.noOfSeats')} :  {storeDetails.seatCount}<br />
            {t('store.smoking')} :  {storeDetails.smokingInfo && storeDetails.smokingInfo.smokingDetail}<br />
            {t('store.parking')} :  {storeDetails.parkingInfo && storeDetails.parkingInfo.parkingDetail}<br />
            {t('store.storeHP')} :   <a href={storeDetails.shopHP} target="_blank" rel="noreferrer">{storeDetails.shopHP}</a> <br />
            {t('store.instagram')} :   <a href={storeDetails.instagram} target="_blank" rel="noreferrer">{storeDetails.instagram}</a><br />
            {t('store.facebook')} :   <a href={storeDetails.facebook} target="_blank" rel="noreferrer">{storeDetails.facebook}</a><br />
            {t('store.twitter')} :   <a href={storeDetails.twitter} target="_blank" rel="noreferrer">{storeDetails.twitter}</a><br />
          </div>
        </div>

        <div className="col-md-6">
          <div className="shop-icon d-flex align-items-center mb-3">
            {storeDetails.foodCateGroups && storeDetails.foodCateGroups.map((item: any, index: number) => {
              const res = {
                ...item,
                id: index
              }
              return res
            }).map((item: any) => (
              <button type="button" className="btn btn-sm btn-outline me-2" key={item.id}>
                <img src={getIconByName(item.name)} alt="" />
                {` ${item.name === 'その他' ? 'ホテル' : item.name}`}
              </button>
            ))}
            <button type="button" className="btn btn-sm btn-pubple me-2">{getLocation(storeDetails.location)}</button>
            {
              storeDetails.marks
              && storeDetails.marks.map((item: any, index: number) => {
                const res = {
                  ...item,
                  id: index
                }
                return res
              }).map((item: any) => (
                <img key={item.id} className=" me-2" src={item.imageUrl} height="50" alt="" />
              ))
            }
          </div>
          <h4><img src={playYellow} alt="" />{t('leftSidebar.videoMenuSub1')} / {t('leftSidebar.videoMenuSub2')}</h4>
          <div className="video-detail mt-2 mb-4">
            {storeDetails.preniumVideos
              && storeDetails.preniumVideos.map((item: any, index: number) => {
                const res = {
                  ...item,
                  id: index
                }
                return res
              }).map((item: any) => (

                <div className="video-items" key={id} data-content={item.title} role="presentation" onClick={() => onSelectVideo(item)}>
                  <i className="bi bi-play-circle-fill play-icon" />
                  {
                    item.thumbnailUrl
                      ? <img src={item.thumbnailUrl} alt={item.title} />
                      : (
                        <video height="100%" width="100%">
                          <source src={item.url} type="video/mp4" />
                          <track kind="captions" />
                          Your browser does not support HTML video.
                        </video>

                      )
                  }
                </div>
              ))}
          </div>
          <h4><img src={playRed} alt="" />{t('leftSidebar.videoMenuSub3')}</h4>
          <ListVideoGoLiver id={id} onSelectVideo={onSelectVideo} />
          <VideoGoLiverSummary id={id} />
        </div>
      </div>
      <div className="button-action d-flex mb-5">
        {
          storeDetails.reservationUrl
            ? (
              <a href={storeDetails.reservationUrl} className="btn btn-lg active">店舗予約する</a>
            )
            : (
              <button type="button" className="btn btn-lg btn-secondary">店舗予約する</button>
            )
        }
        {
          storeDetails.deliveryUrl
            ? (
              <a href={storeDetails.deliveryUrl} className="btn btn-lg active">デリバリーする</a>
            )
            : (
              <button type="button" className="btn btn-lg btn-secondary">デリバリーする</button>
            )
        }
        {
          storeDetails.purchaseUrl
            ? (
              <a href={storeDetails.purchaseUrl} className="btn btn-lg active">すぐ買う</a>
            )
            : (
              <button type="button" className="btn btn-lg btn-secondary">すぐ買う</button>
            )
        }
      </div>
    </div>

  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreDetails)
